type Props = {
  className?: string;
};

const EndOfResultsIllustration = ({ className }: Props) => (
  <svg
    className={className}
    viewBox="0 0 80 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.81382 12.0185C4.14242 15.1772 2.35043 29.5822 1.91336 36.3899C-1.49579 56.3492 6.10925 67.0243 15.9433 71.5173C25.7774 76.0104 38.234 74.5127 50.8216 74.2404C63.4092 73.9681 68.2607 75.6019 74.9479 62.1228C81.6351 48.6436 80.3239 36.3899 77.8326 29.7184C75.3413 23.0469 66.2939 15.6946 57.2465 8.07005C48.1992 0.445485 37.9717 -2.27757 30.6289 2.07932C23.2861 6.43621 12.4031 8.07005 7.81382 12.0185Z"
      fill="#F9FAFB"
    />
    <path
      d="M25.8398 48.4929L43.1607 18.4923C44.6608 15.894 47.9833 15.0037 50.5817 16.5039L75.2956 30.7725C77.8939 32.2726 78.7842 35.5951 77.284 38.1935L59.9632 68.1941C58.463 70.7924 55.1405 71.6827 52.5422 70.1825L27.8283 55.914C25.2299 54.4138 24.3397 51.0913 25.8398 48.4929Z"
      fill="white"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M32.9662 43.6962L45.6223 21.7751C46.3724 20.4759 48.0337 20.0308 49.3328 20.7809L72.0229 33.881C73.3221 34.6311 73.7672 36.2923 73.0171 37.5915L60.361 59.5126C59.6109 60.8118 57.9497 61.2569 56.6505 60.5068L33.9604 47.4067C32.6612 46.6566 32.2161 44.9954 32.9662 43.6962Z"
      fill="#FEE9EF"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M44.7814 61.858L30.3631 53.5336C29.1421 52.8287 28.7237 51.2674 29.4287 50.0464C30.1336 48.8254 31.6949 48.407 32.9159 49.112L47.3342 57.4364C48.5552 58.1413 48.9736 59.7026 48.2686 60.9236C47.5637 62.1446 46.0024 62.563 44.7814 61.858Z"
      stroke="black"
      strokeWidth="0.271628"
    />
    <path
      d="M12.2227 59.7579V14.9393C12.2227 11.939 14.6549 9.50671 17.6552 9.50671H50.3659C51.9325 9.50671 53.4227 10.183 54.4543 11.3619L59.0925 16.6626C59.959 17.653 60.4366 18.9241 60.4366 20.24V59.7579C60.4366 62.7582 58.0044 65.1904 55.0041 65.1904H17.6552C14.6549 65.1904 12.2227 62.7582 12.2227 59.7579Z"
      fill="white"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M16.8398 49.7086V17.5207C16.8398 16.0206 18.056 14.8044 19.5561 14.8044H52.8305C54.3307 14.8044 55.5468 16.0206 55.5468 17.5207V49.7086C55.5468 51.2088 54.3307 52.4249 52.8305 52.4249H19.5561C18.056 52.4249 16.8398 51.2088 16.8398 49.7086Z"
      fill="#FEE9EF"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M27.7061 39.1164C28.7115 37.9393 31.778 35.5852 36.0008 35.5852C40.2236 35.5852 43.4578 37.9393 44.547 39.1164"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <circle cx="28.3853" cy="30.8279" r="0.950698" fill="#111928" />
    <circle cx="43.5952" cy="30.8279" r="0.950698" fill="#111928" />
    <path
      d="M40.4714 61.118H20.0993C18.3741 61.118 16.9756 59.7195 16.9756 57.9943C16.9756 56.2691 18.3741 54.8706 20.0993 54.8706H40.4714C42.1966 54.8706 43.5951 56.2691 43.5951 57.9943C43.5951 59.7195 42.1966 61.118 40.4714 61.118Z"
      fill="#FEE9EF"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M70.2977 10.7054C69.7784 8.2888 67.627 6.92434 66.3315 6.48009C66.1468 6.41674 65.9519 6.51799 65.8794 6.6993C65.7993 6.89955 65.8966 7.12693 66.0949 7.21154C66.3547 7.32233 66.6812 7.46737 66.9567 7.60514C68.3875 8.32054 69.1191 9.75967 69.4089 10.7262C69.4888 10.9926 69.6878 11.2447 69.9533 11.162C70.1238 11.1088 70.3352 10.8801 70.2977 10.7054Z"
      fill="white"
    />
    <path
      d="M3.87793 49.9923C4.34097 51.045 5.18164 51.8857 6.23438 52.3488L6.71387 52.5597L6.23438 52.7706C5.18164 53.2337 4.34096 54.0743 3.87793 55.1271L3.66699 55.6066L3.45605 55.1271C2.99303 54.0743 2.15234 53.2337 1.09961 52.7706L0.619141 52.5597L1.09961 52.3488C2.15233 51.8857 2.99302 51.045 3.45605 49.9923L3.66699 49.5118L3.87793 49.9923Z"
      fill="#FDC8D3"
      stroke="#111928"
      strokeWidth="0.5"
    />
    <path
      d="M74.0186 19.6271C74.5304 20.7347 75.4198 21.6229 76.5273 22.1349C75.4197 22.6468 74.5305 23.536 74.0186 24.6437C73.5066 23.5361 72.6184 22.6467 71.5107 22.1349C72.6183 21.623 73.5067 20.7346 74.0186 19.6271Z"
      fill="#FDC8D3"
      stroke="#111928"
      strokeWidth="0.5"
    />
  </svg>
);

export default EndOfResultsIllustration;
